import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {ptBR} from "date-fns/locale/pt-BR";

// interface DateStyledProps {
//   label: string;
//   name: string;
//   value?: string | null;
//   onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
// }
interface DateStyledProps {
  id?: string;
  name: string;
  label: string;
  value?: string;
  onChange: (...args: any) => void;
}

function parseLocalDateOnly(value?: string): Date | null {
  const raw = String(value ?? "").trim();
  if (!raw) return null;
  const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  if (!y || mo < 1 || mo > 12 || d < 1 || d > 31) return null;
  return new Date(y, mo - 1, d, 12, 0, 0, 0);
}

function formatLocalDateOnly(value: Date | null): string {
  if (!value) return "";
  const y = value.getFullYear();
  const m = String(value.getMonth() + 1).padStart(2, "0");
  const d = String(value.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

const DateStyled: React.FC<DateStyledProps> = ({ label, name, value, onChange }) => {
  const parsedValue = parseLocalDateOnly(value);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <DatePicker
        label={label}
        value={parsedValue}
        onChange={(newValue) => {
          const isoDate = formatLocalDateOnly(newValue);
          onChange({
            target: { name, value: isoDate },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
        slotProps={{
          textField: {
            fullWidth: true,
            size: "small",
            name,
            sx: {
              backgroundColor: "#f1f1f1",
                "& .MuiOutlinedInput-root": {
                  height: "40px", 
                "& fieldset": { borderColor: "#000" },
                "&:hover fieldset": { borderColor: "#76A6C2" },
                "&.Mui-focused fieldset": { borderColor: "#76A6C2" },
              },
              "& .MuiFormControl-root": {
                width: "100%",
              },

              "& .MuiInputBase-input": {
                color: "#000",
                padding: "0 14px 0 30px", 

              },
              "& .MuiInputLabel-root": { color: "#666" },
              "& .MuiInputLabel-root.Mui-focused": { color: "#76A6C2" },
            },
          },
          desktopPaper: {
            sx: {
              backgroundColor: "#f1f1f1", // fundo do calendário
              "& .MuiPickersDay-root.Mui-selected": {
                backgroundColor: "#76A6C2", // data selecionada
                color: "#fff",
              },
              "& .MuiPickersDay-root:hover": {
                backgroundColor: "#bff3ed",
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DateStyled;
